app.service("MenuService", ['$rootScope', '$document', function ($rootScope, $document) {

    const service = this;

    const MenuModel = function () {
        this.is_cart_visible = false;
        this.is_sidebar_wrapper_visible = false;
        this.use_sticky_header = false;
        this.last_path_selection = window.location.pathname;
        this.edit_solution_cart_called = false;
    };

    this.model = new MenuModel();
    const model = this.model;

    this.toggleCartVisible = function () {
        service.setCartVisible(!model.is_cart_visible);
    }

    this.setCartVisible = function (value) {
        if (value !== model.is_cart_visible) {
            model.is_cart_visible = value;
            $rootScope.$broadcast("menu_is_cart_visible_change");
        }
    }

    this.setSidebarWrapperVisible = function (value) {
        if (value !== model.is_sidebar_wrapper_visible) {
            model.is_sidebar_wrapper_visible = value;
        }
    }

    $rootScope.$on('$stateChangeSuccess', function () {
        service.setCartVisible(false);
        service.setSidebarWrapperVisible(false);
        model.last_path_selection = window.location.pathname;
    });

    $rootScope.$on('key_down', function ($event, $params) {
        const keyCode = $params && $params.event && $params.event.originalEvent ? $params.event.originalEvent.keyCode : null;
        if (keyCode === 27) {
            service.setSidebarWrapperVisible(false);
        }
    });

    function updateUseStickyHeader(fromScroll) {

        const useStickyHeader = window.pageYOffset > 60;
        if (useStickyHeader !== model.use_sticky_header) {
            model.use_sticky_header = useStickyHeader;
            if (fromScroll) {
                $rootScope.$apply();
            }
        }
    }

    updateUseStickyHeader();

    $document.on('scroll', function () {
        updateUseStickyHeader(true)
    })
}]);